export const messages = {
  en: {
    addQuestionAnswer: {
      title: 'Add Questionnaire',
      qaName: 'Questionnaire Name',
      qaNamePlaceholder: 'Required, please fill in the questionnaire name',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please select end time',
      content: 'Questionnaire Description',
      contentPlaceholder: 'Required, please enter questionnaire description',
      questionTitle: 'Questionnaire Questions',
      chooseTitle: 'Select Questions',
      questionRoom: 'Questionnaire Rooms',
      qaNameRequired: 'Questionnaire name is required',
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      timeInvalid: 'End time must be later than start time',
      contentRequired: 'Questionnaire description is required',
      titleRequired: 'Please select at least one question',
      roomRequired: 'Please select at least one room',
      titleExist: 'This question has already been selected',
      confirmDeleteTitle: 'Are you sure to delete this question?',
      saveSuccess: 'Questionnaire saved successfully',
      saveError: 'Failed to save questionnaire'
    },
    selectRoom: {
      buildingUnit: 'Building Unit',
      roomInfo: 'Room Information',
      unit: 'Unit',
      loadError: 'Failed to load building units',
      loadRoomError: 'Failed to load rooms'
    },
    chooseQuestionTitle: {
      title: 'Select Questions',
      searchPlaceholder: 'Enter question name',
      question: 'Question',
      operation: 'Operation',
      choose: 'Choose',
      queryError: 'Failed to query questions'
    }
  },
  zh: {
    addQuestionAnswer: {
      title: '添加问卷',
      qaName: '问卷名称',
      qaNamePlaceholder: '必填，请填写问卷名称',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请选择开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请选择结束时间',
      content: '问卷说明',
      contentPlaceholder: '必填，请输入问卷说明',
      questionTitle: '问卷题目',
      chooseTitle: '选择题目',
      questionRoom: '问卷房屋',
      qaNameRequired: '问卷名称不能为空',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空',
      timeInvalid: '结束时间必须晚于开始时间',
      contentRequired: '问卷说明不能为空',
      titleRequired: '请至少选择一个题目',
      roomRequired: '请至少选择一间房屋',
      titleExist: '该题目已被选择',
      confirmDeleteTitle: '确定删除该题目吗？',
      saveSuccess: '问卷保存成功',
      saveError: '问卷保存失败'
    },
    selectRoom: {
      buildingUnit: '楼栋单元',
      roomInfo: '房屋信息',
      unit: '单元',
      loadError: '加载楼栋单元失败',
      loadRoomError: '加载房屋信息失败'
    },
    chooseQuestionTitle: {
      title: '选择题目',
      searchPlaceholder: '输入题目名称',
      question: '题目',
      operation: '操作',
      choose: '选择',
      queryError: '查询题目失败'
    }
  }
}